<template>
  <div v-if="linkRedirects.length > 0" class="link-redirect-block">
    <h3 class="link-redirect-title">{{ $t("labels.yourAccess") }}</h3>
    <div class="link-redirect-list">
      <a
        v-for="(link, index) in linkRedirects"
        :key="index"
        :href="link.url"
        target="_blank"
        rel="noopener noreferrer"
        class="link-redirect-item"
      >
        <svg viewBox="0 0 16 16" aria-hidden="true" focusable="false">
          <path
            fill="currentColor"
            fill-rule="evenodd"
            d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5z"
          />
          <path
            fill="currentColor"
            fill-rule="evenodd"
            d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0z"
          />
        </svg>
        <span>{{ link.label }}</span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "LinkRedirect",
  computed: {
    linkRedirects() {
      return window?.productDetails?.linkRedirects || [];
    },
  },
};
</script>

<style scoped>
.link-redirect-block {
  margin-top: 1.5rem;
  padding: 1rem 1.25rem;
  background: #f8f9fa;
  border-radius: 0.5rem;
  border: 1px solid #dee2e6;
}

.link-redirect-title {
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 0.75rem;
  color: #212529;
}

.link-redirect-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.link-redirect-item {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.625rem 1rem;
  background: #fff;
  border: 1px solid #dee2e6;
  border-radius: 0.375rem;
  color: #0d6efd;
  text-decoration: none;
  font-weight: 500;
  transition:
    background 0.15s,
    border-color 0.15s;
}

.link-redirect-item svg {
  width: 1em;
  height: 1em;
  flex: 0 0 auto;
  display: block;
}

.link-redirect-item:hover {
  background: #e7f1ff;
  border-color: #0d6efd;
  text-decoration: none;
  color: #0a58ca;
}
</style>
